var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F4F4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 16.25V26.7a.8.8 0 00.8.8h10.9a.8.8 0 00.8-.8V16.25M20 17.5v6.25M11.25 14.375h17.5",
    stroke: "#262A33",
    strokeOpacity: 0.9,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.375l.578-2.31a.25.25 0 01.242-.19h5.86a.25.25 0 01.242.19l.578 2.31",
    stroke: "#3C3F47",
    strokeWidth: 1.5
  })));
}
export default __webpack_public_path__ + "static/contact_delete.1184cabd.svg";
export { SvgContactDelete as ReactComponent };